// extracted by css-extract-rspack-plugin
export default {"cls1":"ErrorStateFeed-cls1_EVZ","cls2":"ErrorStateFeed-cls2_1i_ ErrorStateFeed-cls1_EVZ"};